//include 3
jQuery(function () {
	if (window.pixelpoint.isMobile.any() !== null) {
		$('.main-nav').removeClass('mousehover'); // disabling mouse hover if mobile(touch) device
		$('.menu-level-1 > a').on("touchstart", function (e) {
			e.preventDefault();
			//console.log('click');
			if ($(this).parent().hasClass('hover')) {
				//console.log('stripping hover');
				$('.menu-level-1').removeClass('hover');
			} else {
				$('.menu-level-1').removeClass('hover');
				$(this).parent().addClass('hover');
				//console.log('touching hover');
			}
		});
		$('.supersection > a').on("touchstart", function (e) {
			e.preventDefault();
			setTimeout(() => {
				$('.supersection').removeClass('hover');
				$(this).parent().toggleClass('hover');
			}, 10);
		});
	}
});